module.exports = __webpack_public_path__ + "img/list.9ab87b99.png";